import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useModal } from '../context/ModalContext';

const Footer = () => {
  const { openModal } = useModal();

  return (
    <footer className="footer" id="about">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-col">
            <h4><span style={{ fontSize: '1.5rem' }}>🇧🇼</span> Le-Ma Systems Botswana</h4>
            <ul>
              <li>
                <LocationOnIcon fontSize="small" className="icon" />
                Unit C9, Plot 75068, Block 5,<br />Gaborone, Botswana
              </li>
              <li>
                <PhoneIcon fontSize="small" className="icon" />
                (+267) 75 410 129
              </li>
              <li>
                <EmailIcon fontSize="small" className="icon" />
                info@lema.systems
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4><span style={{ fontSize: '1.5rem' }}>🇿🇦</span> Le-Ma Systems S.A.</h4>
            <ul>
              <li>
                <LocationOnIcon fontSize="small" className="icon" />
                Fleurhof, Florida,<br />Johannesburg
              </li>
              <li>
                <PhoneIcon fontSize="small" className="icon" />
                +27 81 547 7008
              </li>
              <li>
                <EmailIcon fontSize="small" className="icon" />
                info.sa@lema.systems
              </li>
            </ul>
          </div>

          <div className="footer-col">
            <h4 style={{ opacity: 0.8 }}>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#process">Process</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><button onClick={openModal} className="text-primary" style={{ background: 'none', border: 'none', padding: 0, font: 'inherit', cursor: 'pointer' }}>Start a Project &rarr;</button></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2026 Le-Ma Systems. All rights reserved.</p>
          <p>Redefining the digital age through technology that empowers.</p>
          <div className="social-links">
            <a href="https://linkedin.com"><LinkedInIcon /></a>
            <a href="https://facebook.com"><FacebookIcon /></a>
            <a href="https://whatsapp.com"><WhatsAppIcon /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
